var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgN3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #005799;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.21,22.87c0,1.82-.51,3.31-1.53,4.47-1.02,1.16-2.47,1.93-4.35,2.32v.16c2.29.29,3.99,1.02,5.1,2.19,1.11,1.17,1.66,2.71,1.66,4.61,0,2.72-.94,4.81-2.83,6.28-1.89,1.46-4.57,2.2-8.05,2.2-1.51,0-2.89-.11-4.15-.34-1.26-.23-2.48-.63-3.66-1.2v-3.09c1.24.61,2.55,1.08,3.96,1.4,1.4.32,2.72.48,3.97.48,4.93,0,7.4-1.93,7.4-5.8,0-3.46-2.72-5.2-8.16-5.2h-2.81v-2.79h2.85c2.23,0,3.99-.49,5.29-1.47,1.3-.98,1.95-2.35,1.95-4.09,0-1.39-.48-2.49-1.44-3.28s-2.26-1.19-3.9-1.19c-1.25,0-2.43.17-3.54.51-1.11.34-2.37.96-3.79,1.88l-1.64-2.19c1.17-.92,2.52-1.65,4.05-2.18,1.53-.53,3.14-.79,4.83-.79,2.77,0,4.93.63,6.46,1.9,1.54,1.27,2.3,3.01,2.3,5.22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgN3);
export default __webpack_public_path__ + "static/media/n3.411b97424921e67d37e317eb166f9587.svg";
export { ForwardRef as ReactComponent };